var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCone1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M93.2841 160.344C102.177 160.344 110.982 158.592 119.198 155.189C127.413 151.786 134.878 146.799 141.166 140.511C147.454 134.223 152.442 126.758 155.845 118.542C159.248 110.327 160.999 101.521 160.999 92.6287L93.2841 92.6287L93.2841 160.344Z",
    fill: "#FDBC64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M52.3734 105.678C59.2512 105.678 66.0617 104.323 72.4159 101.691C78.7701 99.0593 84.5437 95.2015 89.4071 90.3382C94.2704 85.4749 98.1282 79.7013 100.76 73.347C103.392 66.9928 104.747 60.1824 104.747 53.3046L52.3734 53.3046L52.3734 105.678Z",
    fill: "#E8F2FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCone1);
export default __webpack_public_path__ + "static/media/cone1.d448ac5e42dd7eae73e7309d9df2d70a.svg";
export { ForwardRef as ReactComponent };